import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MdMenu } from 'react-icons/md';
import logoGc from "../../../imgs/LogoGcDarkBg.png";

function NavbarComponent({ logout, setSidebarOpen,showSidebar }) {
    return (
        <Navbar expand="lg" className="navbar-custom justify-content-around fixed-top">
            <Container className="w-100 justify-content-around m-0">
                {
                    showSidebar &&  <button className="sidebar-toggle-btn" onClick={setSidebarOpen}>
                                        <MdMenu />
                                    </button>
                }
                <Navbar.Brand href="/home">
                    <img src={logoGc} className='Logo-image' alt="logo-gecimmo" />
                </Navbar.Brand>
                <Navbar.Toggle className="navbar-toggle-user" aria-controls="basic-navbar-nav" />
                <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Link onClick={logout}>Logout</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavbarComponent;
